import { Component, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../../constants/constant.content'
import { SearchFilter } from '../../services/data-filters/search-filter'
import { FundLiteratureContentService } from '../../services/fund-literature/fund-literature.service'
import { ObservableService } from '../../services/observable-service/observable.service'
import { PolarisDataService } from '../../services/polaris-service/polaris-data-service'

@Component({
  selector: 'fund-list',
  templateUrl: './fund-list.component.html',
  styleUrls: ['./fund-list.component.scss'],
})
export class FundListComponent implements OnInit {
  fd3ContentGenericListResponse: any
  caasContent: any
  viewType: string
  isPolarisDataLoaded = true
  fd3tableContentList: any
  footNoteCaas: any
  noData: any
  fundLiteratureContentServiceError = false
  isFundLiteratureContentValueFetch = false

  constructor(
    private readonly observableService: ObservableService,
    public readonly searchFilter: SearchFilter,
    private readonly polarisDataService: PolarisDataService,
    private readonly fd3FundLiteratureContentService: FundLiteratureContentService,
  ) {
    this.polarisDataService.retrieveData((isDataFetchSuccess: boolean) => {
      this.isPolarisDataLoaded = isDataFetchSuccess
      if (isDataFetchSuccess) {
        this.getFundLiteratureData()
      }
      this.searchFilter.performFundClassification()
    })
  }

  ngOnInit(): void {
    this.caasContent = JSON.parse(
      sessionStorage.getItem(SESSION_STORAGE_CONSTANTS_CAAS_CONTENT),
    )
    this.fd3ContentGenericListResponse =
      this.caasContent.data.fd3genericList.items[0]
    this.fd3tableContentList =
      this.caasContent.data.fd3tablecontentList.items[0]
    this.footNoteCaas = this.caasContent.data.fd3footnotesList.items[0]
    this.noData = this.caasContent.data.fd3errorsList.items[0]
    this.observableService.viewTypeValue.subscribe((value: string) => {
      this.viewType = value
    })
  }

  getFundLiteratureData() {
    this.fd3FundLiteratureContentService
      .getFD3FundLiteratureContent()
      .subscribe({
        next: (literatureData: any) => {
          this.fd3FundLiteratureContentService.setFundLiteratureData(
            literatureData,
          )
          this.fd3FundLiteratureContentService.setFactSheetData()
          this.observableService.changeIsFundLiteratureContentValueFetch(true)
          this.isFundLiteratureContentValueFetch = true
        },
        error: (error: any) => {
          this.isFundLiteratureContentValueFetch = true
          console.log('Failed to fetch fund literature service data !!', error)
          this.fundLiteratureContentServiceError = true
        },
      })
  }
}
